import React, { ReactNode } from "react";

import { isDefined } from "Utils/functions";
import { HyperlinkVariable } from "../textInterfaces";
import { LinkComponentWrapper } from "../textStyled";

export const createMarkup = (
  componentText: string,
  hyperlinks: Record<string, HyperlinkVariable>,
  isFormHint: boolean,
): ReactNode => {
  const markup = componentText.split(/\s+/).map((element, index) => {
    if (!element.startsWith("{{")) {
      return <span key={element + index}>{element} </span>;
    }

    const matches = element.match(/{{(\w+)}}/);

    if (!isDefined(matches)) {
      return;
    }

    // first capture group
    const variableName = matches[1];
    const trailingCharacters = element.match(/}}(.+)/)?.[1];

    return (
      <>
        <a
          key={element + index}
          href={hyperlinks[variableName].url}
          target="_blank"
          rel="noreferrer"
        >
          {hyperlinks[variableName].text}
        </a>
        {isDefined(trailingCharacters) ? (
          <span>{trailingCharacters}</span>
        ) : null}
        &nbsp;
      </>
    );
  });

  return (
    <LinkComponentWrapper isFormHint={isFormHint}>
      {markup.map((el) => el)}
    </LinkComponentWrapper>
  );
};
